export default "__VITE_PUBLIC_ASSET__c8896e75__"